import { render, staticRenderFns } from "./showroom.vue?vue&type=template&id=34143e95&scoped=true&"
import script from "./showroom.vue?vue&type=script&lang=js&"
export * from "./showroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34143e95",
  null
  
)

export default component.exports